"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Disclaimer = void 0;
const tslib_1 = require("tslib");
const catalog_core_1 = require("@tableau/catalog-core");
const catalog_help_url_1 = require("@tableau/catalog-help-url");
const catalog_messages_1 = require("@tableau/catalog-messages");
const raw_1 = require("@tableau/icons/WelcomeIcon/raw");
const widgets_1 = require("@tableau/widgets");
const react_1 = tslib_1.__importDefault(require("react"));
function Disclaimer(props) {
    const href = (0, catalog_help_url_1.useServerHelpUrlByToken)({ helpToken: 'core', editionOverride: 'online', prefix: 'gpt' });
    const link = (react_1.default.createElement(widgets_1.TextLinkWidget, { href: href, testId: 'help', target: '_blank', rel: 'noopener noreferrer' }, catalog_messages_1.Messages.LearnMoreLink()));
    const text = catalog_messages_1.Messages.GenAIDisclaimerContent({ learnMoreLink: '[LEARN_MORE_LINK]' });
    const content = (react_1.default.createElement("div", { style: {
            fontSize: widgets_1.TabStyles.Typography.Sizing.Default,
            marginTop: 0,
            marginBottom: widgets_1.TabStyles.Spacing.LargeSpace,
        } }, (0, catalog_core_1.interpolateString)(text, { ['LEARN_MORE_LINK']: link }).map((t, i) => react_1.default.createElement(react_1.default.Fragment, { key: i }, t))));
    const [shouldShow, setShouldShow] = react_1.default.useState(localStorage.getItem('show-catalog-gen-AI-disclaimer') === null);
    react_1.default.useEffect(() => {
        if (!shouldShow) {
            localStorage.setItem('show-catalog-gen-AI-disclaimer', 'false');
            props.setShowDisclaimer(false);
        }
    }, [shouldShow, props]);
    return shouldShow
        ? (react_1.default.createElement("div", null, react_1.default.createElement(widgets_1.DialogWidget, { isModal: true, dialogWidth: 375, dialogHeight: 263, onCloseRequest: () => undefined, showCloseButton: false, testId: 'genAI-disclaimer', title: '', type: widgets_1.DialogType.NormalWithoutTitleBar, positioningBehavior: widgets_1.DialogPositioningBehavior.Centered },
            react_1.default.createElement("div", { style: {
                    flexDirection: 'column',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100%',
                } },
                react_1.default.createElement("img", { width: 50, height: 50, src: `data:image/svg+xml,${encodeURIComponent((0, raw_1.WelcomeIconRaw)(40))}`, alt: 'alt' }),
                react_1.default.createElement("p", { style: { fontSize: widgets_1.TabStyles.Typography.Sizing.XLarge, color: widgets_1.TabStyles.Typography.Color.PrimaryDark } }, catalog_messages_1.Messages.GenAIDisclaimerTitle()),
                content,
                react_1.default.createElement(widgets_1.ButtonWidget, { buttonType: widgets_1.ButtonType.Primary, onClick: () => {
                        setShouldShow(false);
                    } }, catalog_messages_1.Messages.GotIt())))))
        : react_1.default.createElement(react_1.default.Fragment, null);
}
exports.Disclaimer = Disclaimer;
//# sourceMappingURL=Disclaimer.js.map